"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CheckboxOption", {
  enumerable: true,
  get: function get() {
    return _checkboxOption["default"];
  }
});
Object.defineProperty(exports, "CheckboxInline", {
  enumerable: true,
  get: function get() {
    return _checkboxInline["default"];
  }
});
Object.defineProperty(exports, "CheckboxBlock", {
  enumerable: true,
  get: function get() {
    return _checkboxBlock["default"];
  }
});
exports["default"] = void 0;

var _checkboxOption = _interopRequireDefault(require("./checkbox-option"));

var _checkboxGroup = _interopRequireDefault(require("./checkbox-group"));

var _checkboxInline = _interopRequireDefault(require("./checkbox-inline"));

var _checkboxBlock = _interopRequireDefault(require("./checkbox-block"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// deprecated
// deprecated
var _default = _checkboxGroup["default"];
exports["default"] = _default;